import React from 'react'
import {
  Divider,
  // DraggableList,
  Input,
  TextArea,
} from '@st-operations/uikit/src/v2'

import LookbackSelect, { LOOKBACK_VALUES } from '_components/lookback-select'
import SelectedEntitiesEditor from './SelectedEntitiesEditor.jsx'
import SelectedTopicsEditor from './SelectedTopicsEditor'
import RecommendedSegmentsSignals from './RecommendedSegmentsSignals'

import {
  BASE_SLIDES,
  AVAILABLE_SLIDES,
  DEPRECATED_SLIDES,
  EDIT_FIELDS,
} from './constants/availableSlides'
import { BE_SOCIAL_CHANNELS } from './constants/slidesSchema.js'

import './EditSlidePane.scss'
import SocialChannelsSelector from './SocialChannelsSelector.jsx'

const EditSlidePane = ({ slides, categoryOverindex, index, onFieldChange, audienceId }) => {
  const slide = slides[index]
  const { data, constraint } = slide

  const slideSchema = [...BASE_SLIDES, ...AVAILABLE_SLIDES].find(
    ({ template }) => template === slide.template
  )

  // TODO: declare which to use, instead of which to don't
  const NOT_INPUTS = [
    'constraint',
    'note',
    'footnote',
    'selected_entities',
    'default_options',
    'type',
  ]

  const onInputChange = (field) => (value, name) => {
    onFieldChange({ index, value, type: name, field })
  }

  const onTextAreaChange = (field) => (event, name, value) => {
    onFieldChange({ index, value, type: name, field })
  }

  const onLookbackChange = (field) => (value) => {
    onFieldChange({ index, value, type: null, field })
  }

  const onSocialChannelsChange = (field) => (selectedChannels) => {
    onFieldChange({ index, value: selectedChannels, type: null, field })
  }

  return (
    <div className="edit-slide-pane mac-scrollbar" style={{ '--mac-scrollbar-bk': '#fdfdfd' }}>
      <Choose>
        <When condition={slideSchema?.editableFields?.length}>
          <For each="field" index="fieldIndex" of={slideSchema.editableFields}>
            <React.Fragment key={fieldIndex}>
              <Choose>
                <When condition={slide.template === 'Intro'}>
                  <Input
                    label="Title"
                    name="title"
                    onChange={onInputChange(field)}
                    value={data[field].title}
                  />
                </When>
                <When condition={field === EDIT_FIELDS.HEADER}>
                  <Input
                    label="Title"
                    name="title"
                    onChange={onInputChange(field)}
                    value={data.title}
                  />
                  <If condition={!field.includes('transition') && data.description !== 'none'}>
                    <TextArea
                      label="Description"
                      name="description"
                      onChange={onTextAreaChange(field)}
                      value={data.description}
                    />
                  </If>
                </When>
                <When
                  condition={
                    field === EDIT_FIELDS.SEC1 && slide.template !== 'Recommended_Segments'
                  }
                >
                  <For each="item" of={Object.keys(data[field])}>
                    <If condition={!NOT_INPUTS.includes(item)}>
                      <Input
                        label={item[0].toUpperCase() + item.replaceAll('_', ' ').slice(1)}
                        name={item}
                        onChange={onInputChange(field)}
                        value={data[field][item]}
                      />
                    </If>
                    <If condition={item.includes('note') || item === 'segment_criteria'}>
                      <TextArea
                        label={item[0].toUpperCase() + item.replaceAll('_', ' ').slice(1)}
                        name={item}
                        onChange={onTextAreaChange(field)}
                        value={data[field][item]}
                      />
                    </If>
                  </For>
                </When>
                <When condition={field === EDIT_FIELDS.TRANSITION_TITLE}>
                  <Input
                    label="Title"
                    name={field}
                    onChange={onInputChange(field)}
                    value={data[field]}
                  />
                </When>
                <When condition={[EDIT_FIELDS.TOPICS].includes(field)}>
                  <SelectedTopicsEditor
                    field={field}
                    slide={slide}
                    constraint={constraint}
                    index={index}
                    onFieldChange={onFieldChange}
                    audienceId={audienceId}
                  />
                </When>
                <When
                  condition={[
                    EDIT_FIELDS.ENTITIES,
                    EDIT_FIELDS.RECOMMENDED_SEGMENTS_1,
                    EDIT_FIELDS.RECOMMENDED_SEGMENTS_2,
                  ].includes(field)}
                >
                  <SelectedEntitiesEditor
                    field={field}
                    categoryOverindex={categoryOverindex}
                    slide={slide}
                    constraint={constraint}
                    index={index}
                    onFieldChange={onFieldChange}
                  />
                </When>
                <When condition={field === EDIT_FIELDS.RECOMMENDED_SEGMENTS_3}>
                  <RecommendedSegmentsSignals
                    slide={slide}
                    field={field}
                    index={index}
                    onFieldChange={onFieldChange}
                  />
                </When>
                <When condition={field === EDIT_FIELDS.LOOKBACK}>
                  <Divider className="selected-entities-editor__divider" />
                  <LookbackSelect
                    lookback={data.lookback ?? LOOKBACK_VALUES.MONTH_6}
                    onLookbackChange={onLookbackChange(field)}
                  />
                </When>
                <When condition={field === EDIT_FIELDS.SOCIAL_CHANNELS}>
                  <Divider className="selected-entities-editor__divider" />
                  <SocialChannelsSelector
                    selectedChannels={
                      data.selected_channels ??
                      Object.keys(BE_SOCIAL_CHANNELS).map((channel) => channel.toLowerCase())
                    }
                    onSocialChannelsChange={onSocialChannelsChange(field)}
                  />
                </When>
              </Choose>
            </React.Fragment>
          </For>
        </When>
        <Otherwise>
          <p>This slide is not editable.</p>
          {DEPRECATED_SLIDES[slide.template] && <p>{DEPRECATED_SLIDES[slide.template]}</p>}
        </Otherwise>
      </Choose>
    </div>
  )
}

export default EditSlidePane
